module.exports = __webpack_public_path__ + "static/img/gukesh d.607845b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/gukesh d.jpg
// module id = 474
// module chunks = 11